import React, { useState } from "react";
import {
  Container, Typography, Box, Paper, Tabs, Tab, TextField,
  InputAdornment, IconButton, MenuItem, Select, FormControl, InputLabel
} from "@mui/material";
import { Search, ArrowBackIos } from "@mui/icons-material";
import { Link, useParams } from "react-router-dom";
import { ProductosGrupales } from "./ProductosGrupales";
import { NuevoPresupuestoGrupal } from "./NuevoPresupuestoGrupal";

export const GroupPackagesPage: React.FC = () => {
  const { category } = useParams<{ category: string }>();
  const [tabValue, setTabValue] = useState<number>(0);
  const [terminoBusqueda, setTerminoBusqueda] = useState<string>('');
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const categoryTitles: Record<string, string> = {
    quince: "Quince",
    egresados: "Egresados",
    educativos: "Educativos",
    eventos: "Eventos",
    otros: "Otros"
  };

  const title = categoryTitles[category || ""] || "Grupales";

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => setTabValue(newValue);
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => setTerminoBusqueda(event.target.value);

  const handlePackageCreated = () => {
    setTabValue(0);
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Container maxWidth={false} sx={{ px: { xs: 2, md: 4 }, py: 1 }}>
      <Typography variant="h5" sx={{ mb: 3, mt: 4.5, display: 'flex', alignItems: 'center' }}>
        <IconButton aria-label="volver" size="small" component={Link} to="/paquetes-grupales">
          <ArrowBackIos fontSize="small" />
        </IconButton>
        Paquetes {title}
      </Typography>

      <Paper elevation={2} sx={{ borderRadius: 3, border: 1, borderColor: 'divider', px: 2, py: 1, mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="navegación paquetes grupales"
            sx={{ minHeight: 48 }}
          >
            <Tab label="Productos Vigentes" sx={{ minHeight: 48, mr: 4 }} />
            <Tab label="Nuevo Producto" sx={{ minHeight: 48, mr: 4 }} />
            <Tab label="Finalizados" sx={{ minHeight: 48, mr: 4 }} />
          </Tabs>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 1 }}>
            <Box sx={{ minWidth: 300 }}>
              <TextField
                size="small"
                placeholder={`Buscar en ${title}...`}
                value={terminoBusqueda}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                sx={{ width: '100%' }}
              />
            </Box>
          </Box>
        </Box>
      </Paper>

      {tabValue === 0 && (
        <ProductosGrupales 
          category={category} 
          terminoBusqueda={terminoBusqueda} 
          refreshTrigger={refreshTrigger}
          modoVisualizacion="vigentes"
        />
      )}
      {tabValue === 1 && (
        <NuevoPresupuestoGrupal 
          category={category} 
          onPackageCreated={handlePackageCreated} 
        />
      )}
      {tabValue === 2 && (
        <ProductosGrupales 
          category={category} 
          terminoBusqueda={terminoBusqueda} 
          refreshTrigger={refreshTrigger}
          modoVisualizacion="finalizados"
        />
      )}
    </Container>
  );
};

export default GroupPackagesPage;
